// auth and login
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_ERROR = "AUTH_ERROR";
export const UPDATE_FULLNAME = "UPDATE_FULLNAME";

// Forget password
export const FORGET_PASSWORD_START = "FORGET_PASSWORD_START";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_FAIL = "CHECK_CODE_FAIL";

export const CHECK_CODE_START = "CHECK_CODE_START";
export const CHECK_CODE_SUCCESS = "CHECK_CODE_SUCCESS";
export const CHECK_CODE_FAIL = "CHECK_CODE_FAIL";

export const RESET_PASSWORD_START = "RESET_PASSWORD_START";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";

export const RESET_PASSWORD_CLEAR = "RESET_PASSWORD_CLEAR";

// user info
export const FETCH_INFO_START = "FETCH_INFO_START";
export const FETCH_INFO_SUCCESS = "FETCH_INFO_SUCCESS";
export const FETCH_INFO_FAIL = "FETCH_INFO_FAIL";
export const UPDATE_INFO_START = "UPDATE_INFO_START";
export const UPDATE_INFO_SUCCESS = "UPDATE_INFO_SUCCESS";
export const UPDATE_INFO_FAIL = "UPDATE_INFO_FAIL";
export const UPDATE_CLEAR_SUCCESS_MSG = "UPDATE_CLEAR_SUCCESS_MSG";

export const UPDATE_PASSWORD_START = "UPDATE_PASSWORD_START";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAIL = "UPDATE_PASSWORD_FAIL";
export const CLEAR_ERROR = "CLEAR_ERROR";

// user picture
export const FETCH_PIC_START = "FETCH_PIC_START";
export const FETCH_PIC_SUCCESS = "FETCH_PIC_SUCCESS";
export const FETCH_PIC_FAIL = "FETCH_PIC_FAIL";

export const UPLOAD_PIC_START = "UPLOAD_PIC_START";
export const UPLOAD_PIC_SUCCESS = "UPLOAD_PIC_SUCCESS";
export const UPLOAD_PIC_FAIL = "UPLOAD_PIC_FAIL";

// user folders
export const FETCH_FOLDERS_START = "FETCH_FOLDERS_START";
export const FETCH_FOLDERS_SUCCESS = "FETCH_FOLDERS_SUCCESS";
export const FETCH_FOLDERS_FAIL = "FETCH_FOLDERS_FAIL";

export const CREATE_FOLDERS_START = "CREATE_FOLDERS_START";
export const CREATE_FOLDERS_SUCCESS = "CREATE_FOLDERS_SUCCESS";
export const CREATE_FOLDERS_FAIL = "CREATE_FOLDERS_FAIL";

export const RENAME_FOLDERS_START = "RENAME_FOLDERS_START";
export const RENAME_FOLDERS_SUCCESS = "RENAME_FOLDERS_SUCCESS";
export const RENAME_FOLDERS_FAIL = "RENAME_FOLDERS_FAIL";

export const DELETE_FOLDERS_START = "DELETE_FOLDERS_START";
export const DELETE_FOLDERS_SUCCESS = "DELETE_FOLDERS_SUCCESS";
export const DELETE_FOLDERS_FAIL = "DELETE_FOLDERS_FAIL";

export const CLEAR_MSG_USER_FOLDER = "CLEAR_MSG_USER_FOLDER";
export const SELECT_FOLDER = "SELECT_FOLDER";

// for files
export const OPEN_FOLDER = "OPEN_FOLDER";
export const CLOSE_FOLDER = "CLOSE_FOLDER";
export const FETCH_FILES_START = "FETCH_FILES_START";
export const FETCH_FILES_SUCCESS = "FETCH_FILES_SUCCESS";
export const FETCH_FILES_FAIL = "FETCH_FILES_FAIL";

export const UPLOAD_FILE_START = "UPLOAD_FILE_START";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAIL = "UPLOAD_FILE_FAIL";
export const UPLOAD_FILE_PROGRESS = "UPLOAD_FILE_PROGRESS";

export const RENAME_FILE_START = "RENAME_FILE_START";
export const RENAME_FILE_SUCCESS = "RENAME_FILE_SUCCESS";
export const RENAME_FILE_FAIL = "RENAME_FILE_FAIL";

export const DELETE_FILE_START = "DELETE_FILE_START";
export const DELETE_FILE_SUCCESS = "DELETE_FILE_SUCCESS";
export const DELETE_FILE_FAIL = "DELETE_FILES_FAIL";

export const CLEAR_MSG_USER_FILE = "CLEAR_MSG_USER_FILE";

export const SELECT_FILE = "SELECT_FILE";

// -----for Milestone-----

export const FETCH_USER_PROJECTS_FOR_MILESTONE_START =
  "FETCH_USER_PROJECTS_FOR_MILESTONE_START";
export const FETCH_USER_PROJECTS_FOR_MILESTONE_SUCCESS =
  "FETCH_USER_PROJECTS_FOR_MILESTONE_SUCCESS";
export const FETCH_USER_PROJECTS_FOR_MILESTONE_FAIL =
  "FETCH_USER_PROJECTS_FOR_MILESTONE_FAIL";

export const FETCH_USER_MILESTONES_START = "FETCH_USER_MILESTONES_START";
export const FETCH_USER_MILESTONES_SUCCESS = "FETCH_USER_MILESTONES_SUCCESS";
export const FETCH_USER_MILESTONES_FAIL = "FETCH_USER_MILESTONES_FAIL";

export const USER_MILESTONE_PERCENT = "USER_MILESTONE_PERCENT";
export const CLEAR_USER_MSG_MILESTONE = "CLEAR_USER_MSG_MILESTONE";

///////////////////////// for Admin Clients //////////////////

// ------------ Manage Account-------------
export const SET_ACCOUNT_ID = "SET_ACCOUNT_ID";

export const FETCH_ACCOUNT_START = "FETCH_ACCOUNT_START";
export const FETCH_ACCOUNT_SUCCESS = "FETCH_ACCOUNT_SUCCESS";
export const FETCH_ACCOUNT_FAIL = "FETCH_ACCOUNT_FAIL";

export const UPDATE_ACCOUNT_START = "UPDATE_ACCOUNT_START";
export const UPDATE_ACCOUNT_SUCCESS = "UPDATE_ACCOUNT_SUCCESS";
export const UPDATE_ACCOUNT_FAIL = "UPDATE_ACCOUNT_FAIL";

export const DELELTE_ACCOUNT_START = "DELELTE_ACCOUNT_START";
export const DELELTE_ACCOUNT_SUCCESS = "DELELTE_ACCOUNT_SUCCESS";
export const DELELTE_ACCOUNT_FAIL = "DELELTE_ACCOUNT_FAIL";

export const CLEAR_ACCOUNT_MSG = "CLEAR_ACCOUNT_MSG";

// ------------ clients-------------
export const SET_USER_ID = "SET_USER_ID";
export const FETCH_USERS_START = "FETCH_USERS_START";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAIL = "FETCH_USERS_FAIL";

// -client
export const FETCH_CLIENT_FILES_START = "FETCH_CLIENT_FILES_START";
export const FETCH_CLIENT_FILES_SUCCESS = "FETCH_CLIENT_FILES_SUCCESS";
export const FETCH_CLIENT_FILES_FAIL = "FETCH_CLIENT_FILES_FAIL";

export const CREATE_CLIENT_START = "CREATE_CLIENT_START";
export const CREATE_CLIENT_SUCCESS = "CREATE_CLIENT_SUCCESS";
export const CREATE_CLIENT_FAIL = "CREATE_CLIENT_FAIL";

export const DELETE_CLIENT_SUCCESS = "DELETE_CLIENT_SUCCESS";

export const CLEAR_SUCCESS_MSG = "CLEAR_SUCCESS_MSG";

// clients folder
export const SELECT_CLIENT_FOLDER = "SELECT_CLIENT_FOLDER";
export const FETCH_USER_FOLDERS_START = "FETCH_USER_FOLDERS_START";
export const FETCH_USER_FOLDERS_SUCCESS = "FETCH_USER_FOLDERS_SUCCESS";
export const FETCH_USER_FOLDERS_FAIL = "FETCH_USER_FOLDERS_FAIL";

export const CREATE_FOLDER_CLIENT_START = "CREATE_FOLDER_CLIENT_START";
export const CREATE_FOLDER_CLIENT_SUCCESS = "CREATE_FOLDER_CLIENT_SUCCESS";
export const CREATE_FOLDER_CLIENT_FAIL = "CREATE_FOLDER_CLIENT_FAIL";

export const RENAME_CLIENT_FOLDERS_START = "RENAME_CLIENT_FOLDERS_START";
export const RENAME_CLIENT_FOLDERS_SUCCESS = "RENAME_CLIENT_FOLDERS_SUCCESS";
export const RENAME_CLIENT_FOLDERS_FAIL = "RENAME_CLIENT_FOLDERS_FAIL";

export const DELETE_CLIENT_FOLDERS_START = "DELETE_CLIENT_FOLDERS_START";
export const DELETE_CLIENT_FOLDERS_SUCCESS = "DELETE_CLIENT_FOLDERS_SUCCESS";
export const DELETE_CLIENT_FOLDERS_FAIL = "DELETE_CLIENT_FOLDERS_FAIL";

export const CLEAR_MSG_CLIENT_FOLDER = "CLEAR_MSG_CLIENT_FOLDER";

// clients files
export const SELECT_CLIENT_FILE = "SELECT_CLIENT_FILE";
export const UPLOAD_FILE_CLIENT_START = "UPLOAD_FILE_CLIENT_START";
export const UPLOAD_FILE_CLIENT_SUCCESS = "UPLOAD_FILE_CLIENT_SUCCESS";
export const UPLOAD_FILE_CLIENT_FAIL = "UPLOAD_FILE_CLIENT_FAIL";
export const UPLOAD_FILE_CLIENT_PROGRESS = "UPLOAD_FILE_CLIENT_PROGRESS";

export const RENAME_CLIENT_FILE_START = "RENAME_CLIENT_FILE_START";
export const RENAME_CLIENT_FILE_SUCCESS = "RENAME_CLIENT_FILE_SUCCESS";
export const RENAME_CLIENT_FILE_FAIL = "RENAME_CLIENT_FILE_FAIL";

export const DELETE_CLIENT_FILE_START = "DELETE_CLIENT_FILE_START";
export const DELETE_CLIENT_FILE_SUCCESS = "DELETE_CLIENT_FILE_SUCCESS";
export const DELETE_CLIENT_FILE_FAIL = "DELETE_CLIENT_FILE_FAIL";

export const CLEAR_MSG_CLIENT_FILE = "CLEAR_MSG_CLIENT_FILE";

//---------- for Admin Admins----------
export const SET_ADMIN_ID = "SET_ADMIN_ID";
export const FETCH_ADMINS_START = "FETCH_ADMINS_START";
export const FETCH_ADMINS_SUCCESS = "FETCH_ADMINS_SUCCESS";
export const FETCH_ADMINS_FAIL = "FETCH_ADMINS_FAIL";

export const DELETE_ADMIN_SUCCESS = "DELETE_ADMIN_SUCCESS";

//---------- for Admin CLinet Project----------
export const FETCH_CLIENT_PROJECTS_START = "FETCH_CLIENT_PROJECTS_START";
export const FETCH_CLIENT_PROJECTS_SUCCESS = "FETCH_CLIENT_PROJECTS_SUCCESS";
export const FETCH_CLIENT_PROJECTS_FAIL = "FETCH_CLIENT_PROJECTS_FAIL";

export const CREATE_CLIENT_PROJECT_START = "CREATE_CLIENT_PROJECT_START";
export const CREATE_CLIENT_PROJECT_SUCCESS = "CREATE_CLIENT_PROJECT_SUCCESS";
export const CREATE_CLIENT_PROJECT_FAIL = "CREATE_CLIENT_PROJECT_FAIL";

export const DELETE_CLIENT_PROJECT_START = "DELETE_CLIENT_PROJECT_START";
export const DELETE_CLIENT_PROJECT_SUCCESS = "DELETE_CLIENT_PROJECT_SUCCESS";
export const DELETE_CLIENT_PROJECT_FAIL = "DELETE_CLIENT_PROJECT_FAIL";

export const SELECT_CLIENT_PROJECT = "SELECT_CLIENT_PROJECT";
export const CLEAR_MSG_CLIENT_PROJECT = "CLEAR_MSG_CLIENT_PROJECT";

//---------- for Admin CLinet Project Mlestone----------
export const FETCH_PROJECT_MILESTONES_START = "FETCH_PROJECT_MILESTONES_START";
export const FETCH_PROJECT_MILESTONES_SUCCESS =
  "FETCH_PROJECT_MILESTONES_SUCCESS";
export const FETCH_PROJECT_MILESTONES_FAIL = "FETCH_PROJECT_MILESTONES_FAIL";

export const CREATE_PROJECT_MILESTONE_START = "CREATE_PROJECT_MILESTONE_START";
export const CREATE_PROJECT_MILESTONE_SUCCESS =
  "CREATE_PROJECT_MILESTONE_SUCCESS";
export const CREATE_PROJECT_MILESTONE_FAIL = "CREATE_PROJECT_MILESTONE_FAIL";

export const UPDATE_STATUS_PROJECT_MILESTONE_START =
  "UPDATE_STATUS_PROJECT_MILESTONE_START";
export const UPDATE_STATUS_PROJECT_MILESTONE_SUCCESS =
  "UPDATE_STATUS_PROJECT_MILESTONE_SUCCESS";
export const UPDATE_STATUS_PROJECT_MILESTONE_FAIL =
  "UPDATE_STATUS_PROJECT_MILESTONE_FAIL";

export const DELETE_PROJECT_MILESTONE_START = "DELETE_PROJECT_MILESTONE_START";
export const DELETE_PROJECT_MILESTONE_SUCCESS =
  "DELETE_PROJECT_MILESTONE_SUCCESS";
export const DELETE_PROJECT_MILESTONE_FAIL = "DELETE_PROJECT_MILESTONE_FAIL";

export const FETCH_CLIENT_PROJECTS_FOR_MILESTONE_START =
  "FETCH_CLIENT_PROJECTS_FOR_MILESTONE_START";
export const FETCH_CLIENT_PROJECTS_FOR_MILESTONE_SUCCESS =
  "FETCH_CLIENT_PROJECTS_FOR_MILESTONE_SUCCESS";
export const FETCH_CLIENT_PROJECTS_FOR_MILESTONE_FAIL =
  "FETCH_CLIENT_PROJECTS_FOR_MILESTONE_FAIL";

export const MILESTONE_PERCENT = "MILESTONE_PERCENT";
export const CLEAR_MSG_PROJECT_MILESTONE = "CLEAR_MSG_PROJECT_MILESTONE";

export const SELECT_PROJECT_ID = "SELECT_PROJECT_ID";
export const CLEAR_PROJECT_ID = "CLEAR_PROJECT_ID";
export const SELECT_PROJECT_MILESTONES = "SELECT_PROJECT_MILESTONES";


///////////////// for client project period /////////////

export const FETCH_CLIENT_PROJECT_PERIOD_START ="FETCH_CLIENT_PROJECT_PERIOD_START";
export const FETCH_CLIENT_PROJECT_PERIOD_SUCCESS ="FETCH_CLIENT_PROJECT_PERIOD_SUCCESS";
export const FETCH_CLIENT_PROJECT_PERIOD_FAIL ="FETCH_CLIENT_PROJECT_PERIOD_FAIL";

export const CREATE_CLIENT_PROJECT_PERIOD_START ="CREATE_CLIENT_PROJECT_PERIOD_START";
export const CREATE_CLIENT_PROJECT_PERIOD_SUCCESS ="CREATE_CLIENT_PROJECT_PERIOD_SUCCESS";
export const CREATE_CLIENT_PROJECT_PERIOD_FAIL ="CREATE_CLIENT_PROJECT_PERIOD_FAIL";
